module.exports = __webpack_public_path__ + "img/big7-5.4e4cc7c2.jpg";